import e from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { DialtoneLocalization as n } from "../../localization/index.js";
import { BREADCRUMBS_INVERTED_MODIFIER as r } from "./breadcrumbs-constants.js";
import i from "./breadcrumb-item.js";
import { Fragment as a, createBlock as o, createElementBlock as s, createElementVNode as c, mergeProps as l, normalizeClass as u, openBlock as d, renderList as f, renderSlot as p, resolveComponent as m } from "vue";
//#region components/breadcrumbs/breadcrumbs.vue
var h = {
	compatConfig: { MODE: 3 },
	name: "DtBreadcrumbs",
	components: { DtBreadcrumbItem: i },
	props: {
		breadcrumbs: {
			type: Array,
			default: () => [],
			validate(e) {
				return e.every(({ href: e, label: t }) => e !== void 0 && t !== void 0);
			}
		},
		inverted: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			BREADCRUMBS_INVERTED_MODIFIER: r,
			i18n: new n()
		};
	},
	methods: { getBreadcrumbItemKey(t) {
		return `breadcrumbs-item-${t}-${e.getUniqueString()}`;
	} }
}, g = ["aria-label"];
function _(e, t, n, r, i, h) {
	let _ = m("dt-breadcrumb-item");
	return d(), s("nav", {
		"aria-label": n.ariaLabel || i.i18n.$t("DIALTONE_BREADCRUMBS_ARIA_LABEL"),
		"data-qa": "dt-breadcrumbs",
		class: u(["d-breadcrumbs", { [i.BREADCRUMBS_INVERTED_MODIFIER]: n.inverted }])
	}, [c("ol", null, [p(e.$slots, "default", {}, () => [(d(!0), s(a, null, f(n.breadcrumbs, (e, t) => (d(), o(_, l({
		key: h.getBreadcrumbItemKey(t),
		inverted: n.inverted
	}, { ref_for: !0 }, e), null, 16, ["inverted"]))), 128))])])], 10, g);
}
var v = /* @__PURE__ */ t(h, [["render", _]]);
//#endregion
export { v as default };

//# sourceMappingURL=breadcrumbs.js.map